import { Navigate, useLocation } from 'react-router-dom';
import { useAuthStore } from '../stores/useAuthStore';

export default function ProtectedRoute({ children, action }) {
  const location = useLocation();
  const checkAuth = useAuthStore((state) => state.checkAuth);
  const isAuth = checkAuth(); // Check authentication from store

  if (isAuth) {
    return children;
  }

  return (
    <Navigate
      to="/"
      replace
      state={{
        openAuth: true,
        action,
        redirectTo: `${location.pathname}${location.search}${location.hash}`,
      }}
    />
  );
}
